import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Badge from 'react-bootstrap/Badge';

function FundingPayrollDelayedForm({ fundingIsDelayedAfterPayrollCluster }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Payroll Delayed:</Form.Label>
      </Col>
      <Col md={1} className="bo-same-line">
        <Badge className="bo-badge" bg={fundingIsDelayedAfterPayrollCluster ? 'danger' : 'success'}>
          {fundingIsDelayedAfterPayrollCluster ? 'Yes' : 'No'}
        </Badge>
      </Col>
    </>
  );
}
export default memo(FundingPayrollDelayedForm);
